<div class="ui-file-icon ui-file-icon--{{ classModifier }}">
  @if (icon) {
    <campus-icon data-cy="file-icon" [svgIcon]="icon"></campus-icon>
  }
  @if (label) {
    <div>{{ label }}</div>
  }
</div>
